import html from '../legacy/crypto.html?raw';
import { LegacyHtmlPage } from './LegacyHtmlPage';

export function Crypto() {
  return <LegacyHtmlPage slug="crypto" title="Cryptographic Algorithms" html={html} />;
}
